import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { StyledLink, StyledAnchor, ArrowCircle } from "./style";

type ArrowLinkProps = {
  to: string;
  isInternalDestination: boolean;
  text?: string;
  ariaLabel?: string;
  onClick?: () => void;
  textFirst?: boolean;
  className?: string;
};

const ArrowLink: React.FC<ArrowLinkProps> = ({
  to,
  isInternalDestination,
  text,
  ariaLabel,
  onClick,
  textFirst = false,
  className,
}: ArrowLinkProps) => {
  const arrowIcon = (
    <ArrowCircle>
      <FontAwesomeIcon icon={faArrowRight} />
    </ArrowCircle>
  );

  const content = textFirst ? (
    <>
      {text}
      {arrowIcon}
    </>
  ) : (
    <>
      {arrowIcon}
      {text}
    </>
  );

  if (isInternalDestination) {
    return (
      <StyledLink
        to={to}
        data-test-id="arrow-link"
        aria-label={ariaLabel}
        onClick={onClick}
        className={className}
      >
        {content}
      </StyledLink>
    );
  }

  return (
    <StyledAnchor
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      data-test-id="arrow-link"
      aria-label={ariaLabel}
      onClick={onClick}
      className={className}
    >
      {content}
    </StyledAnchor>
  );
};

export default ArrowLink;
